import React from 'react';
import { useRemoveGoalMutation } from '../../../api/useRemoveGoalMutation';
import { toast } from '../../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../../CommonConstants';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';

interface Props {
  clientId: string;
  goalId: string;
  onClose(): void;
}

export const RemoveGoalModal = ({ clientId, goalId, onClose }: Props) => {
  const { mutateAsync: removeGoal, isLoading: isRemovingGoal } = useRemoveGoalMutation();

  const handleRemoveGoal = async () => {
    try {
      await removeGoal({ clientId, goalId });
    } catch (err) {
      console.error(err);

      toast.error(MESSAGES.GENERIC_ERROR);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      size="medium"
      aria={{ labelledby: 'pulseCheck--remove-goal--confirmation-modal' }}
    >
      <ModalHeader as="h2" variant="warning" id="pulseCheck--remove-goal--confirmation-modal">
        Remove Goal?
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Text>Are you sure you want to remove this goal?</Text>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onClose} variant="subtleInactive" mr="12">
          Cancel
        </Button>

        <Button variant="error" onClick={handleRemoveGoal} isLoading={isRemovingGoal}>
          Remove Goal
        </Button>
      </ModalFooter>
    </Modal>
  );
};
